// src/client/screens/borrower/HomeScreen.tsx
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useActiveLoan } from '@client/hooks/useLoan';
import { useCreditScore } from '@client/hooks/useCreditScore';
import { useAuth } from '@client/auth/useAuth';
import Card from '@client/components/Card';
import CreditScoreGauge from '@client/components/CreditScoreGauge';
import LoanCard from '@client/components/LoanCard';
import Button from '@client/components/Button';
import ScreenShell from '@client/components/ScreenShell';
import Money from '@client/components/Money';
import { maxLoanForTier } from '@client/utils/creditScoreUtils';

export default function HomeScreen() {
  const { profile } = useAuth();
  const { data: loan } = useActiveLoan();
  const { data: score } = useCreditScore();
  const navigate = useNavigate();

  const first = profile?.full_name?.trim().split(/\s+/)[0];
  const greet = first || 'there';

  return (
    <ScreenShell title={`Hi ${greet}`}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Card>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div className="eyebrow">You can borrow up to</div>
              <strong style={{ fontSize: 28 }}>
                <Money amount={score ? maxLoanForTier(score.tier) : null} decimals={0} />
              </strong>
            </div>
            {score && <CreditScoreGauge score={score} />}
          </div>
          <div style={{ marginTop: 16 }}>
            <Button block size="lg" onClick={() => navigate(ROUTES.loanApply)}>
              Apply for a loan
            </Button>
          </div>
        </Card>

        {loan && <LoanCard loan={loan} />}
      </div>
    </ScreenShell>
  );
}
